import * as CONSTANT from '../constants';
import {
  PULSE_CLICK_ACTION,
  PULSE_CLICK_CATEGORY,
  resolveHeaderPulseClickCategory,
  resolvePulseClickViewId,
  trackPulseClick,
} from './pulseClickIds';
import { resolvePhase1RouteViewId } from './pulseViewIds';

const CHECKOUT_PATHS = new Set([
  CONSTANT.ROUTE_CHECKOUT,
  CONSTANT.ROUTE_CHECKOUT_DELIVERY,
  CONSTANT.ROUTE_CHECKOUT_CURBSIDE,
]);

/** First URL segment → snake_case page name (no `_page` suffix). */
export const toPageNameSlugFromPathname = (pathname: string): string => {
  const path = pathname.replace(/\/+$/, '') || '/';
  if (path === '/') return 'home';

  const segment = path.slice(1).split('/')[0].replace(/\.html$/i, '');
  return (
    segment
      .replace(/([a-z0-9])([A-Z])/g, '$1_$2')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '') || 'unknown'
  );
};

/**
 * Pulse click `category` for the current page (`menu_page`, `checkout_page`, …).
 * Uses known ARD mappings first, then explicit routes, then `{segment}_page`.
 */
export const resolvePagePulseClickCategory = (
  pathname: string,
  rewardsCategory: string | null = null
): string => {
  const headerCategory = resolveHeaderPulseClickCategory(pathname, rewardsCategory);
  if (headerCategory) return headerCategory;

  const path = pathname.replace(/\/+$/, '') || '/';

  if (CHECKOUT_PATHS.has(path)) {
    return PULSE_CLICK_CATEGORY.CHECKOUT_PAGE;
  }
  if (path.startsWith(`${CONSTANT.ROUTE_ORDER}/`)) {
    return PULSE_CLICK_CATEGORY.PRODUCT_PAGE;
  }
  if (path === CONSTANT.ROUTE_KIDS_COMBO || path.startsWith('/try2')) {
    return PULSE_CLICK_CATEGORY.PRODUCT_PAGE;
  }

  return `${toPageNameSlugFromPathname(pathname)}_page`;
};

/** Header / global “change location” tap — fires on every page with page-scoped category. */
export function trackChangeLocationClick(params: {
  pathname: string;
  rewardsCategory?: string | null;
  label?: string | null;
}): void {
  const page_path = params.pathname;
  const category = resolvePagePulseClickCategory(
    page_path,
    params.rewardsCategory ?? null
  );
  const view_id =
    resolvePhase1RouteViewId(page_path) ??
    resolvePulseClickViewId(category, page_path);

  trackPulseClick({
    category,
    action: PULSE_CLICK_ACTION.TAP_CHANGE_LOCATION,
    label: params.label ?? null,
    view_id,
    page_id: category,
    page_path,
  });
}
